import { connect } from 'react-redux';
import { getHasCommentedOnDeviation } from '../../../../../../redux/deviations/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return {
        hasCommentedOn: getHasCommentedOnDeviation(state, deviation),
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=CommentControl.container.js.map